<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="客户" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.customerName" placeholder="请输入客户名称"></el-input>
					</el-form-item>
					<el-form-item label="联系人姓名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.linkUser" placeholder="请输入联系人姓名"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入联系电话"></el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="adduser"> 新增 </el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			
			<el-table-column prop="id" label="用户ID" sortable align="center" width="90">
			</el-table-column>
			<el-table-column prop="customerName" label="客户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="linkUser" label="联系人姓名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="电话" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="identity" label="身份介绍" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="wx" label="微信号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="qq" label="QQ" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="email" label="邮箱" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="photos" label="照片"  align="center" >
                <template slot-scope="scope">
					<span v-if="!scope.row.photos">暂无</span>
                    <el-button v-else size="small" type="text" @click="introduce(scope.row.photos)">
						查看</el-button>
                </template>
			</el-table-column>
			<el-table-column label="地址" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<span>{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="添加时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center">
				　　　　<template slot-scope="scope">
					　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">
						编辑</el-button>
						<el-button size="small" type="text" @click="toDelete(scope.row.id)">
							删除</el-button>
				</template>
				
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="userList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="userList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		
		<!-- 新增 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisibleuser" width="920px">
			<div class="app-container" style="text-align: center;padding-right: 80px">
				<el-form size="medium">
					<div style="display: flex;justify-content:  space-between;">
						<el-form-item label-width="120px"  label="客户" style="width:400px">
							<el-select filterable v-model="userInfo.customerId" placeholder="请选择" clear style="width:100%">
								<el-option v-for="it in factoryList" :key="it.id" 
                                :value="it.id" :label="it.customerName"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="姓名" style="width: 400px" label-width="120px">
							<el-input type="text" clearable v-model="userInfo.linkUser" placeholder="请输入联系人姓名" />
						</el-form-item>
                        <el-form-item label="电话" style="width: 400px;" label-width="120px">
							<el-input type="text" clearable v-model="userInfo.phone" placeholder="请输入联系人电话" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="微信号" style="width:400px" label-width="120px">
							<el-input type="text" clearable v-model="userInfo.wx" placeholder="请输入联系人微信号" />
						</el-form-item>
                        <el-form-item label="QQ号" style="width: 400px;" label-width="120px">
							<el-input type="text" clearable v-model="userInfo.qq" placeholder="请输入联系人QQ号" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="邮箱" label-width="120px" style="width:400px">
							<el-input type="text" clearable v-model="userInfo.email" placeholder="请输入联系人邮箱" />
						</el-form-item>
                    </div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="身份介绍" label-width="120px" style="width:800px">
							<el-input type="textarea" :rows="2" v-model="userInfo.identity"  
							placeholder="请输入身份介绍" />
							<!-- maxlength="32" show-word-limit -->
						</el-form-item>
                    </div>
					
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="所属区域:" label-width="120px" >
                            <el-select clearable filterable v-model="userInfo.provinceId" placeholder="请选择省"
                                @change="provinceFocus">
                                <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select clearable filterable v-model="userInfo.cityId" placeholder="请选择市"
                                @change="cityFcus">
                                <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select clearable filterable v-model="userInfo.areaId" placeholder="请选择区"
                                @change="districtFcus">
                                <el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
					</div>
                    <div>
                        <el-form-item label="详细地址" label-width="120px" style="width:800px">
							<el-input type="text" v-model="userInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
                    </div>
					<div style="display: flex;align-items: center;">
                       <el-form-item label="照片" label-width="120px" 
					   style="width: 100%;display: flex;align-items: initial;">
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" 
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					
					
		
				</el-form>
			</div>
			<div style="text-align: center;margin-top: 100px;">
				<el-button @click="dialogVisibleuser = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增联系人'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑联系人'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false"
        title="详情">
            <div v-if="popupType == 1">
                <el-carousel indicator-position="outside" style="height: 600px;">
                    <el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
                        <img :src="item" style="width: 100%; height: 100%;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div v-if="popupType==2">
                <div v-html="dialogHtml"></div>
            </div>
            <div style="height:30px"></div>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>


	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
    var urls = uploadFile();
    
    import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},  
		data() {
			return {
				userInfo:{},
				loading: false,
				dialogVisibleImg:false,
				dialogImageUrl:[],
				remark:'',
				fileList: [],

				userList: [{}], //用户列表
				propertyDialogVisible: false,
				httpUrl: urls,
				inviteDialogVisible: false,
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName:'',
				editUserDialogVisible: false, // 编辑用户弹窗
				editAgentDialogVisible: false, // 设置代理弹窗
				formLabelWidth: "200px",
				form: {
					username: "",
					password: "",
					surePass: "",
					userLevel: "",
					userLevel: "",
					vipLevel: "",
				},
				photosImages: [],
				photoImages:'',
				page: {
					pageNum: 1,
					pageSize: 10
				},
                searchInfo: {},
                
				//新增弹窗
				dialogVisibleuser:false,
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
                },
                editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},

				logo: "",
                
                popupType: 1, //弹窗类型
                dialogHtml:"",

                factoryList: [],
                froductListShow: [],

                provinceList: {},
				cityList: {},
                districtList: {},
                
                addLoading: false,
                sureLoading: false,
			};
		},
		methods: {
            upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
            },
            uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
            getSheng(){
                //查询省
                this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
            },
            //查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.province = obj.name
				this.userInfo.provinceId = e
				this.userInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				this.userInfo.cityId = e
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
			
            },
            districtFcus(e) {
				this.userInfo.areaId = e
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.area = obj.name
			},
            introduce(e) {
                this.popupType = 1;
				this.dialogImageUrl = e.split(',');
				this.dialogVisibleImg = true;
			},
            sure() { //编辑
                this.sureLoading = true
				let data = {
					address: this.userInfo.address,
                    area: this.userInfo.area,
                    areaId: this.userInfo.areaId,
                    city: this.userInfo.city,
                    cityId: this.userInfo.cityId,
                    province: this.userInfo.province,
                    provinceId: this.userInfo.provinceId,

                    linkUser: this.userInfo.linkUser,
                    phone: this.userInfo.phone,
                    identity: this.userInfo.identity,
                    wx: this.userInfo.wx,
                    qq: this.userInfo.qq, 
                    email: this.userInfo.email,
					photos :this.photoImages.join(','),
					customerId: this.userInfo.customerId,

                    id: this.userInfo.id
				}
			
				this.$api.updateClientLinkman(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
					} else {
						this.$message.error(res.message);
                    }
                    
					this.sureLoading = false
					this.dialogVisibleuser = false;
				})
			},
			add(){
				this.addLoading = true;
				// console.log('新增信息---', data)
				let data={
                    // ...this.userInfo,
                    address: this.userInfo.address,
                    area: this.userInfo.area,
                    areaId: this.userInfo.areaId,
                    city: this.userInfo.city,
                    cityId: this.userInfo.cityId,
                    province: this.userInfo.province,
                    provinceId: this.userInfo.provinceId,

                    linkUser: this.userInfo.linkUser,
                    phone: this.userInfo.phone,
                    identity: this.userInfo.identity,
                    wx: this.userInfo.wx,
                    qq: this.userInfo.qq, 
                    email: this.userInfo.email,
					photos :this.photoImages.join(','),
					customerId: this.userInfo.customerId
                }
                // console.log('新增信息---', data)
				this.$api.addClientLinkman(this.$encrypt(data)).then(res=>{
                    if(res.state=='success'){
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.dialogVisibleuser = false;
                        this.userInfo={}
                        this.getUserList();
                    }
                    this.addLoading = false;
				})
			},
			factoryNoPage(){
				this.$api.factoryNoPage(this.$encrypt({})).then((res) => { 
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
                        // console.log('产品---', res.data)
                        this.factoryList = res.data
					}else{

                    }
				})
			},

			adduser(){
				this.userInfo={}
				this.dialogVisibleuser=true
				this.photosImages=''
				this.fileList=[]
                this.photoImages=[]
                
				this.factoryNoPage();
                

				this.dialogVisibleFunName='新增联系人'
			},
			// 编辑弹窗
			dialogVisibleFun(id) {
				this.factoryNoPage();
				
				this.photoImages=[];
				this.fileList=[];
                this.$api.getClientLinkmanByID(id).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
                    if(res.state == 'success'){
						// console.log('123--', res.data)
                        this.userInfo = res.data;
                        if(res.data.photos){
							this.photoImages = res.data.photos.split(',');
							let arr = res.data.photos.split(',');
							arr.forEach((it)=>{
								this.fileList.push({
									name: it,
									url: it
								})
							})
							
						}
						
                        if(res.data.cityId){
                            this.$api.getArea(res.data.provinceId).then((res) => {
                                if (res.state == 'success') {
                                    this.cityList = res.data
                                }
                            })
                        }
                        if(res.data.areaId){
                            this.$api.getArea(res.data.cityId).then((res) => {
                                if (res.state == 'success') {
                                    this.districtList = res.data
                                }
                            })
                        }
                      
                    }
                    
                })
				this.dialogVisibleuser=true
				this.dialogVisibleFunName='编辑联系人'
			
			},
			//导出
			downloadFile() {
				let data = {
					phone: this.searchInfo.phone,
					id: this.searchInfo.id,
					username: this.searchInfo.username,
					nickname: this.searchInfo.nickname,
					userLevel: this.searchInfo.userLevel,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				// console.log(data);
				this.$api.memberListExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "会员列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
            changeProduct(row, column, cellValue){ //处理主营产品
                let list = [];
                let arr = cellValue.split(',');
                this.getProductList.forEach((item)=>{
                    if( arr.indexOf(item.id+'') != -1 ){
                        list.push(item.className)
                    }
                })
                return list.join(',')
            },
			changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.photoImages.push(response.message);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.photoImages.remove(file.response.message);
				}
				this.photoImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
                this.popupType = 1;
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.logo = res.data
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
	
			//删除
			toDelete(row) {
				var str = "确认删除该客户联系人, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.delClientLinkmanByID(row).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time
						.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				
				}
				this.$api.clientLinkman(this.$encrypt(data)).then((res) => { 
					// console.log(res);
					// console.log('联系人管理列表:', res);
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.userList = res.data
						this.loading = false
					}
				})
			},

            productList(){
                let data = {
					pageNum: 1,
					pageSize: 50,
				}
                this.$api.getProductList(data).then((res) => { 
					if (res.state == 'success') {
                        // console.log('产品---', res.data.list)
                        this.getProductList = res.data.list
					}else{

                    }
				})
            },
		},
		created() {
			this.getUserList();

            // this.productList();
            
            this.getSheng();
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
